import InventoryModal from './InventoryModal';
import enhance from './InventoryModalContainer';

export default enhance(InventoryModal);
